import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const getServiceCategorySettingsByCountryAndRequestType = (countryName, requestType) => {
    return new Promise((resolve, reject) => {

        axios({
          method : "GET",
          url :  api_url + "/public/GetServiceCategorySettingsByCountryAndRequestType",
          params : {'countryName': countryName, 'requestType': requestType},
          headers:  { "Content-Type": "application/json"},
        })
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error); 
                reject(error);
            }
        )
    });
}
